module.exports = __webpack_public_path__ + "static/media/email.b25e5056.svg";